import { render, staticRenderFns } from "./averageDaysOfStockByLocation.vue?vue&type=template&id=65fa95fe&"
import script from "./averageDaysOfStockByLocation.vue?vue&type=script&lang=js&"
export * from "./averageDaysOfStockByLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports